import $ from "jquery";
import {debounce} from "lodash"

export default {
    data() {
        return {
            accessUrl: $("#css-access-url").data("css"),
            nonAccessUrl: $("#styles-css").attr("href"),
            fontSize: $("html").css("fontSize"),
            accessMenuOpen: false,
            hoverSubMenu: false,
            contrastStatus:false
        };
    },
    methods: {
        fontSizePlus() {
            let fontSize = parseInt(this.fontSize) + 1 + "px";
            $("html").css({fontSize: "+=1"});
            this.fontSize = fontSize;
            localStorage.CO_FontSize = fontSize;
        },
        fontSizeMoins() {
            if (parseInt(this.fontSize) > 10) {
                let fontSize = parseInt(this.fontSize) - 1 + "px";
                $("html").css({fontSize: "-=1"});
                this.fontSize = fontSize;
                localStorage.CO_FontSize = fontSize;
            }
        },
        checkFontSize() {
            if (localStorage.CO_FontSize) {
                this.fontSize = localStorage.CO_FontSize;
                $("html").css({fontSize: localStorage.CO_FontSize});
            }
        },
        opacity() {
            if (localStorage.CO_Contrast === "true") {
                $("#styles-css").attr("href", this.nonAccessUrl);
                localStorage.setItem("CO_Contrast", false);
                this.contrastStatus = false
            } else {
                $("#styles-css").attr("href", this.accessUrl);
                localStorage.setItem("CO_Contrast", true);
                this.contrastStatus = true
            }
        },
        checkOpacity() {
            if (localStorage.CO_Contrast === "true") {
                $("#styles-css").attr("href", this.accessUrl);
                this.contrastStatus = true
            }
        },
        fontSizeMoinsLP() {
            if (parseInt(this.fontSize) > 10) {
                let fontSize = "10px";
                $("html").css({fontSize: fontSize});
                this.fontSize = fontSize;
                localStorage.CO_FontSize = fontSize;
            }
        },
        enterAccess() {
            this.accessMenuOpen = true
        },
        leaveAccess: debounce( function() {
            if (this.hoverSubMenu === false){
                this.accessMenuOpen = false
            }
        }, 300)

    },
    mounted() {
        this.checkOpacity();
        this.checkFontSize();
    }
};